export type Params = {
  [key: string]: string | number | undefined;
};

export const composeUrl = (url: string, params: Params): string => {
  if (!url) return '';
  const result = new URL(url);

  
  Object.keys(params).forEach((param) => {
    const paramValue = params[param] ?? '';
    if (paramValue) {
      result.searchParams.set(param, String(paramValue));
    }
  });
  
  result.searchParams.set('iframe', 'true');

  return result.toString();
};
